var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noResult-container"},[_c('i'),_c('p',[_vm._v("暂无识别内容")])])}]

export { render, staticRenderFns }